/** Exact version all five @pdfme/* packages are pinned to; saved templates carry it as `pdfmeVersion`. */
export const PDFME_VERSION_PINNED = "6.2.6";
